import { View } from "binder"
import { SwitchCheckBoxViewModel } from "./switchCheckBox-viewModel"

export class SwitchCheckBoxView extends View<SwitchCheckBoxViewModel>{
    GetViewUniqueId(): string {
        return "V-1D3C1E61-E624-47E5-A67A-84B592ED8C08"
    }
    loadHtml(): string {
        let element = require('./switchCheckBox.html').default;
        let style = require('./switchCheckBox.less');
        return element;
    }
    constructor() {
       super();
    }
    public set checkedContent(v: string) { this._checkedContent = v; } public get checkedContent(): string { return this._checkedContent;} private _checkedContent: string;
    public set uncheckedContent(v: string) { this._uncheckedContent = v; } public get uncheckedContent(): string { return this._uncheckedContent;} private _uncheckedContent: string;
    public set checked(v: boolean) { 
        this._checked = v;
        this.checkbox.checked=v;
    } public get checked(): boolean { return this._checked;} private _checked: boolean;
    public set onoff(v: boolean) { this._onoff = v; } public get onoff(): boolean { return this._onoff;} private _onoff: boolean;
    
    private checkbox:HTMLInputElement;

    changed(){
        this.checked = this.checkbox.checked;
    }

    onRenderCompleted(){
        this.checkbox = this.firstlevelElement.querySelector('.v-1d3c1e61-e624-47e5-a67a-84b592ed8c08-checkbox');
        
    }
}
